import * as types from '../constants/ActionTypes'

const fetch_postSlack = () => () => () => {}

const createBasicCreator = actionType => payload => ({
  type: actionType,
  payload,
})

export const closeSlackPopUp = createBasicCreator(types.CLOSE_SLACK_POPUP)
export const postSlack = fetch_postSlack(types.POST_SLACK)
